import { doc, addDoc, setDoc, deleteDoc } from "../db/firebase.js";
import { casesCollection } from "../db/firebase.js";

export function createCaseCard(
  data,
  id,
  isAdmin,
  openFormModal,
  showDetailModal,
  showConfirm
) {
  const card = document.createElement("div");
  card.className =
    "bg-white p-6 rounded-lg shadow-lg border border-slate-100 relative group";

  let adminButtons = "";
  if (isAdmin) {
    adminButtons = `
      <div class="absolute top-2 right-2 flex gap-2">
          <button class="edit-case-btn bg-orange-400 text-white w-8 h-8 rounded-full flex items-center justify-center shadow-md hover:bg-orange-500" data-id="${id}">
              <i data-lucide="pencil" class="w-4 h-4"></i>
          </button>
          <button class="delete-case-btn bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center shadow-md hover:bg-red-600" data-id="${id}">
              <i data-lucide="trash-2" class="w-4 h-4"></i>
          </button>
      </div>
    `;
  }

  card.innerHTML = `
    ${adminButtons}
    <h3 class="text-xl font-semibold text-orange-900 mb-2">${
      data.title || "Без заголовка"
    }</h3>
    <p class="text-slate-600 mb-4">${data.summary || ""}</p>
    <button class="view-case-btn font-medium text-orange-600 hover:text-orange-800">
        Читать подробнее
    </button>
  `;

  // Просмотр нужного кейса
  const viewBtn = card.querySelector(".view-case-btn");
  if (viewBtn) {
    viewBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      showDetailModal(data);
    });
  }

  // Редактирование кейсов
  const editBtn = card.querySelector(".edit-case-btn");
  if (editBtn) {
    editBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      openFormModal("case", data, id);
    });
  }

  // Удаление кейсов
  const deleteBtn = card.querySelector(".delete-case-btn");
  if (deleteBtn) {
    deleteBtn.addEventListener("click", async (e) => {
      e.stopPropagation();
      showConfirm(
        "Удалить кейс?",
        `Вы уверены, что хотите удалить кейс "${data.title}"?`,
        async () => {
          try {
            await deleteDoc(doc(casesCollection, id));
            console.log(`Кейс ${id} удален.`);
          } catch (error) {
            console.error("Ошибка удаления кейса:", error);
          }
        }
      );
    });
  }

  return card;
}
